'use client'
import { useState } from 'react'
import Button from './Button'
import Link from 'next/link'
import Social from './Social'

const navigation = {
  menu: [
    [
      { name: 'LA FEDERACIÓ', href: '/fcp/nosaltres', className: 'text-white' },
      {
        name: "FEDERA'T",
        href: '/llicencies/solicitud-llicencia',
        className: 'text-white'
      },
      {
        name: 'CONTACTE',
        href: '/fcp/contacte',
        className: 'text-white'
      }
    ],
    [
      {
        name: 'MULTIMEDIA',
        href: '/multimedia/fotos',
        className: 'text-white'
      },
      {
        name: 'FORMACIONS',
        href: '/docencia/formacio-tecnics',
        className: 'text-white'
      },
      { name: "FAQ'S", href: '/faqs', className: 'text-white' }
    ],
    [
      {
        name: 'COMPETICIONS',
        href: '/competicio/calendari/llistat',
        className: 'text-accent'
      }
    ]
  ],
  legal: [
    { name: 'Avís Legal', href: '/avis-legal' },
    { name: 'Política de privacitat', href: '/politica-de-privacitat' },
    { name: 'Política cookies', href: '/cookies' }
  ]
}

const Footer = () => {
  const [email, setEmail] = useState('')

  return (
    <footer className="bg-blue" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto pt-16 px-8 lg:pt-20 pb-8 lg:pb-10 lg:pl-14 lg:pr-20">
        <div className="grid text-center lg:text-left lg:grid-cols-9 pb-8 lg:pb-12">
          <div className="px-8 lg:px-0 lg:col-span-4">
            <h3 className="font-alliance-medium text-white text-[40px]">
              Uneix-te a la nostra newsletter
            </h3>
            <p className="text-white font-alliance-light text-[14px] lg:text-[18px] opacity-60 mt-4 lg:mt-10 mb-8 lg:mb-0">
              Al registrar-te acceptes la Política de privacitat de La Federació
              Catalana de Pàdel. Les seves dades personals, són estrictament pel
              nostre ús i pot cancel·lar la subscripció en qualsevol moment que
              ho desitigi.
            </p>
          </div>
          <div></div>
          <div className="lg:col-span-4">
            <form className="lg:flex">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                type="email"
                name="email-address"
                id="email-address"
                autoComplete="email"
                required
                className="appearance-none text-center lg:text-left pt-5 pb-5 lg:pt-2 lg:pb-2 lg:pl-10 rounded-full lg:rounded-r-none lg:rounded-l-full bg-white pl-4 text-base text-gray-900 font-alliance-medium text-[18px] lg:text-[24px] placeholder-gray-500 placeholder:font-alliance-medium placeholder:text-[18px] lg:placeholder:text-[24px] placeholder:text-blue border-0 w-full"
                placeholder="El teu correu electrònic"
                onChange={(e) => setEmail(e.target.value)}
              />
              <div className="lg:mt-0 lg:flex-shrink-0 lg:rounded-r-full lg:bg-white text-[18px] pt-3 lg:pt-0">
                <Button
                  link={`https://fcpadel.us4.list-manage.com/subscribe?u=fe48aafd5cc3df5056bc32a7c&id=166dfadef3&EMAIL=${email}`}
                  text="Registra’t"
                />
              </div>
            </form>
          </div>
        </div>
        <div className="border-t border-white opacity-30" />

        {/* ONLY MOBILE */}
        <div className="grid grid-cols-3 lg:hidden mt-2 lg:mt-20 mb-10">
          <div className="col-span-2 grid place-content-between">
            <div className="">
              <Social />
            </div>
            <div className="pr-10">
              <img src="/assets/logo-full-white.svg" />
            </div>
          </div>
          <div className="">
            <div className="mt-4">
              {navigation?.menu?.map((item, idx) => (
                <ul
                  key={idx}
                  role="list"
                  className="mt-4 space-y-4 text-right leading-tight"
                >
                  {item?.map((subitem) => (
                    <li key={subitem?.name} className={`${subitem?.className}`}>
                      <Link
                        href={subitem?.href ?? '#'}
                        className={`font-alliance-light text-[13px] hover:underline`}
                      >
                        {subitem?.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
        </div>

        {/* ONLY LG */}
        <div className="hidden lg:flex mt-20 mb-16">
          <div className="mr-16 xl:mr-32">
            <img src="/assets/logo-full-white.svg" />
          </div>
          <div className="grid grid-cols-3 mt-2 gap-10">
            {navigation?.menu?.map((item, idx) => (
              <ul key={idx} role="list" className="mt-4 space-y-4">
                {item?.map((subitem) => (
                  <li key={subitem?.name} className={`${subitem?.className}`}>
                    <Link
                      href={subitem?.href ?? '#'}
                      className={`font-alliance-light text-[14px] hover:underline`}
                    >
                      {subitem?.name}
                    </Link>
                  </li>
                ))}
              </ul>
            ))}
          </div>
          <div className="grow ml-16"></div>
          <div>
            <Social />
          </div>
        </div>
      </div>
      <div className="bg-accent">
        <div className="py-6 flex items-center justify-between mx-4 sm:mx-8 lg:mx-14 font-alliance-medium">
          <div className="flex space-x-2 sm:space-x-4 lg:space-x-6">
            <p className="text-blue text-[12px] lg:text-[14px] font-alliance-medium">
              &copy; {new Date().getFullYear()} Federació Catalana de Pàdel
            </p>
            {navigation?.legal?.map((item, idx) => (
              <p key={idx} className="text-blue text-[12px] lg:text-[14px]">
                <Link href={item?.href ?? '#'} className="group">
                  {item?.name}
                </Link>
              </p>
            ))}
          </div>
          <p className="flex items-end text-blue text-[12px] lg:text-[14px] font-alliance-medium">
            Digital Magic by{' '}
            <Link
              href="https://thedigitalwizards.net"
              passHref
              target="_blank"
              className="hover:underline"
            >
              <img
                src="/assets/logos/tdw-dark.svg"
                className="ml-1"
                alt="TDW"
              />
            </Link>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
